import { fetcher } from "../utils/fetcher";

// Get personal todo lists (legacy endpoint, returns personal only)
export const getTodoLists = async () => {
  try {
    const response = await fetcher.get("/api/todolists");
    return response;
  } catch (error) {
    console.error("Error fetching todo lists:", error);
    throw error;
  }
};

// Get personal todo lists explicitly
export const getPersonalTodoLists = async () => {
  try {
    const response = await fetcher.get("/api/todolists/personal");
    return response;
  } catch (error) {
    console.error("Error fetching personal todo lists:", error);
    throw error;
  }
};

// Get project-scoped todo lists
export const getProjectTodoLists = async (projectId) => {
  try {
    const response = await fetcher.get(`/api/todolists/project/${projectId}`);
    return response;
  } catch (error) {
    console.error("Error fetching project todo lists:", error);
    throw error;
  }
};

export const createTodoList = async (data) => {
  try {
    const response = await fetcher.post("/api/todolists", data);
    return response;
  } catch (error) {
    console.error("Error creating todo list:", error);
    throw error;
  }
};

export const updateTodoList = async (id, data) => {
  try {
    const response = await fetcher.put(`/api/todolists/${id}`, data);
    return response;
  } catch (error) {
    console.error("Error updating todo list:", error);
    throw error;
  }
};

export const deleteTodoList = async (id) => {
  try {
    const response = await fetcher.delete(`/api/todolists/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting todo list:", error);
    throw error;
  }
};

export const reorderTodoLists = async (updates) => {
  try {
    const response = await fetcher.put("/api/todolists/reorder", { updates });
    return response;
  } catch (error) {
    console.error("Error reordering todo lists:", error);
    throw error;
  }
};
